import GeoJSON from 'ol/format/GeoJSON.js';
import {OSM, XYZ, Vector as VectorSource} from 'ol/source.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import {Circle as CircleStyle, Fill, Stroke, Style, Text} from 'ol/style.js';
export class RoadVector{
	constructor(){
		//设置线型
		this.roadStyle = new Style({
			  fill: new Fill({ //矢量图层填充颜色，以及透明度
			    color: 'rgba(255, 255, 255, 0.6)'
			  }),
			  stroke: new Stroke({ //边界样式
			    color: '#319FD3',
			    width: 3
              }),
              text: new Text()
			});
		//城市快速路
            this.fastroadvector = new VectorLayer({
                source: new VectorSource({
                url: 'static/fastroad.json',
                format: new GeoJSON()
                }),
                style: this.roadStyle
            });
            //
            
            //高速公路
            this.highspeedvector = new VectorLayer({
                source: new VectorSource({
                url: 'static/highspeed.json',
                format: new GeoJSON()
                }),
                style: this.roadStyle
            });
            //省道
            this.provector = new VectorLayer({
                source: new VectorSource({
                url: 'static/provlevel.json',
                format: new GeoJSON()
                }),
                style: this.roadStyle
            });

            //国道
            this.countryvector = new VectorLayer({
                source: new VectorSource({
                url: 'static/countrylevel.json',
                format: new GeoJSON()
                }),
                style: this.roadStyle
            });
	}

	loadAllRoadVectors(map){
		map.addLayer(this.fastroadvector);
		map.addLayer(this.highspeedvector);
		map.addLayer(this.provector);
		map.addLayer(this.countryvector);
	}

}


// WEBPACK FOOTER //
// ./src/plugins/js/RoadVector.js